import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'role'
})
export class RolePipe implements PipeTransform {
    transform(value: any, args?: any): any {
	switch (value) {
	case 'product-manager':
        return 'Product Manager';
	case 'Sar':
		return 'Sar'
	case 'planner':
            return 'Planner regional';
	case 'designer':
            return 'Diseñador';
	case 'regional-buyer':
            return 'Comprador regional';
	case 'regional-manager':
            return 'Gerente regional';
	case 'regional-boss':
            return 'Jefe regional';
	case 'country-buyer':
            return 'Comprador país';
	case 'country-planner':
	    return 'Planner país';
	case 'country-boss':
	    return 'Jefe país';
	case 'country-manager':
	    return 'Gerente país';
	case 'comex':
	    return 'Comex'
	default:
            return 'Rol inválido';
	}
    }
}
